import LocationsOverview from './LocationsOverview';

export default LocationsOverview;
